import { render, staticRenderFns } from "./AppModal.vue?vue&type=template&id=2cf166b9&scoped=true"
import script from "./AppModal.vue?vue&type=script&lang=js"
export * from "./AppModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf166b9",
  null
  
)

export default component.exports